export let PriceIncreaseType = /*#__PURE__*/function (PriceIncreaseType) {
  PriceIncreaseType["None"] = "none";
  PriceIncreaseType["Automatic"] = "automatic";
  return PriceIncreaseType;
}({});
export let IncreaseMethodType = /*#__PURE__*/function (IncreaseMethodType) {
  IncreaseMethodType["Percent"] = "percent";
  return IncreaseMethodType;
}({});
export let RoundPrices = /*#__PURE__*/function (RoundPrices) {
  RoundPrices["None"] = "none";
  RoundPrices["Down1"] = "down1";
  RoundPrices["Down5"] = "down5";
  RoundPrices["Down10"] = "down10";
  return RoundPrices;
}({});
export let IncreaseOnType = /*#__PURE__*/function (IncreaseOnType) {
  IncreaseOnType["Yearly"] = "yearly";
  IncreaseOnType["EffectiveDate"] = "yearlyEffectiveDate";
  return IncreaseOnType;
}({});